import MainSection from '../components/mainSection/MainSection';
// import ProductsGrid from '../components/productsGrid/ProductsGrid';
import { Helmet } from 'react-helmet-async';
import ProductsCard from '@/features/homePage/components/products/ProductsCard';

export default function ProductsPage() {
    return (
        <>
            <Helmet>
                <title>Products</title>
                <meta name="description" content="Welcome to our products page. Explore our products and services." />
                <link rel="canonical" href="/products" />
            </Helmet>
            <MainSection />
            <div className="w-full mb-[80px] relative overflow-hidden mainContainer">
                {/* <ProductsGrid /> */}
                <ProductsCard />
            </div>
        </>
    );
}
